import { useTranslation } from 'react-i18next'
import TokenLogo from '~/components/TokenLogo'
import { getNetworkLogo } from '~/utils/chain'
import {
  StyledContainer,
  StyledTitle,
  StyledCommonBase,
  StyledCommonBaseToken,
  TextSymbol,
} from './styled'
import { CommonBaseTokenProps, CommonBaseProps } from './types'

const TokenItem: React.FC<CommonBaseTokenProps> = ({
  logo,
  symbol,
  networkLogo,
  showNetworkBadge,
  onClick,
}) => {
  return (
    <StyledCommonBaseToken onClick={onClick}>
      <TokenLogo
        logo={logo}
        symbol={symbol}
        space={0}
        showNetworkBadge={showNetworkBadge}
        networkLogo={networkLogo}
      />
      <TextSymbol>{symbol}</TextSymbol>
    </StyledCommonBaseToken>
  )
}

const TokenRecommendationsBox: React.FC<CommonBaseProps> = ({
  onTokenSelect,
  recommendTokens = [],
  showNetworkBadge = false,
}) => {
  const { t } = useTranslation()
  if (recommendTokens.length === 0) return null

  return (
    <StyledContainer>
      <StyledTitle>{t('popular_tokens')}</StyledTitle>

      <StyledCommonBase>
        {recommendTokens.map((token) => {
          const { chainId, symbol, address, logo } = token
          const networkLogo = getNetworkLogo(chainId)
          return (
            <TokenItem
              onClick={() => onTokenSelect(token)}
              key={`${chainId}-${address}`}
              symbol={symbol}
              logo={logo}
              networkLogo={networkLogo}
              showNetworkBadge={showNetworkBadge}
            />
          )
        })}
      </StyledCommonBase>
    </StyledContainer>
  )
}

export default TokenRecommendationsBox
